import { validationTypes } from "../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";

const initState = {
  clientName: "",
  ein: "",
  status: "",
};

export const generalInfoFormConfig = {
  name: "Client Details",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic Client Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "clientName",
          label: "Client Name",
          Field_Name: "client name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "clientName",
          fieldSetting: {
            placeholder: "Please enter client name",
             allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "ein",
          label: "EIN",
          Field_Name: "EIN",
          fieldType: FormFieldTypes.MASKINPUT,
          dataField: "ein",
          fieldSetting: {
            placeholder: "12-3456789",
            masking: {
              isMasking: true,
              showMask: true,
              maskFormat: '__-_______',
              maskPlaceholder: "",
              maskReplacement: { _: /\d/ },
            },

          },
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "status",
          label: "Active",
          Field_Name: "Active",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "status",
          fieldSetting: {
            hasMainTitle: " ",
            placeholder: "  ",
          },
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        
      ],
    },
  ],
};
